//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import Translator from '@/services/translator'

//
import PosSaleModel from '@/models/POS/PosSale'
import fields from './fields'

//
export default {
    name: 'pos-sale-update',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                busy: this.busy,
                editable: false,
                fields: fields({
                    g_branch_office_id: 1, //TODO: actualizar branch_office Vuex
                    can_confirm: this.formData.can_confirm,
                    can_edit: this.formData.can_edit,
                }),
                loading: this.busy,
                switchEdit: this.formData.can_edit,
            }
        },
    },
    data() {
        return {
            busy: false,
            formData: {
                pos_detail_sales_edited: [],
                invoice_total_edited: 0,
            },
            loading: true,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        editNewTab: function(edit) {
            if (edit) this.$refs.form.tab = 1
        },

        /**
         *
         */
        fetch() {
            PosSaleModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'pos-sale' })
        },

        /**
         *
         */
        reset() {
            this.fetch()
            this.toggleBusy()
        },

        /**
         *
         */
        setFormData(model) {
            this.busy = false
            this.formData = model.clone().reset()
        },

        /**
         *
         */
        showError(error) {
            this.showSnackbar(
                'error',
                'Error.',
                Translator(PosSaleModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccessEdit() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Ticket de venta actualizada.',
                this.redirect
            )
        },

        /**
         *
         */
        showSuccessConfirm() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Edición de ticket de venta confirmado.',
                this.redirect
            )
        },

        /**
         *
         */
        showSuccessReject() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Edición de ticket de venta rechazado.',
                this.redirect
            )
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.submitEdit)
        },

        /**
         *
         */
        submitConfirm(model) {
            this.$refs.form
                .setWait(true)
                .then(model => model.clone().confirm())
                .then(this.showSuccessConfirm)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        submitEdit(model) {
            model
                .clone()
                .edit()
                .then(this.showSuccessEdit)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        submitReject() {
            this.$refs.form
                .setWait(true)
                .then(model => model.clone().reject())
                .then(this.showSuccessReject)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        toggleBusy() {
            this.busy = !this.busy
        },
    },
    watch: {
        'formData.invoice_total_edited'() {
            console.log('ola')
        }
    },
    beforeMount() {
        this.setTitleTopBar('Detalle de ticket de venta')
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_SALE_TICKET')) ctx.$router.push('/')
        })
    },
}
